export const coachingLink =
	"https://meetings-eu1.hubspot.com/julia-frey-illhardt/zukunftstrends-beratungstermin";
